/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationSettings } from '../models/application-settings';
import { appSettingGetApplicationsetting } from '../fn/app-setting/app-setting-get-applicationsetting';
import { AppSettingGetApplicationsetting$Params } from '../fn/app-setting/app-setting-get-applicationsetting';
import { appSettingGetApplicationSettings } from '../fn/app-setting/app-setting-get-application-settings';
import { AppSettingGetApplicationSettings$Params } from '../fn/app-setting/app-setting-get-application-settings';
import { appSettingGetAppSettingFromGlobalXmlFile } from '../fn/app-setting/app-setting-get-app-setting-from-global-xml-file';
import { AppSettingGetAppSettingFromGlobalXmlFile$Params } from '../fn/app-setting/app-setting-get-app-setting-from-global-xml-file';
import { appSettingGetPracticeSettings } from '../fn/app-setting/app-setting-get-practice-settings';
import { AppSettingGetPracticeSettings$Params } from '../fn/app-setting/app-setting-get-practice-settings';
import { appSettingSaveApplicationSettings } from '../fn/app-setting/app-setting-save-application-settings';
import { AppSettingSaveApplicationSettings$Params } from '../fn/app-setting/app-setting-save-application-settings';
import { appSettingTestEmail } from '../fn/app-setting/app-setting-test-email';
import { AppSettingTestEmail$Params } from '../fn/app-setting/app-setting-test-email';
import { appSettingUpdateApplicationSettings } from '../fn/app-setting/app-setting-update-application-settings';
import { AppSettingUpdateApplicationSettings$Params } from '../fn/app-setting/app-setting-update-application-settings';
import { PracticeSettings } from '../models/practice-settings';

@Injectable({ providedIn: 'root' })
export class AppSettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appSettingGetApplicationSettings()` */
  static readonly AppSettingGetApplicationSettingsPath = '/api/AppSetting/ApplicationSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingGetApplicationSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetApplicationSettings$Response(params?: AppSettingGetApplicationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettings>> {
    return appSettingGetApplicationSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingGetApplicationSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetApplicationSettings(params?: AppSettingGetApplicationSettings$Params, context?: HttpContext): Observable<ApplicationSettings> {
    return this.appSettingGetApplicationSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettings>): ApplicationSettings => r.body)
    );
  }

  /** Path part for operation `appSettingGetPracticeSettings()` */
  static readonly AppSettingGetPracticeSettingsPath = '/api/AppSetting/PracticeSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingGetPracticeSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetPracticeSettings$Response(params?: AppSettingGetPracticeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<PracticeSettings>> {
    return appSettingGetPracticeSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingGetPracticeSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetPracticeSettings(params?: AppSettingGetPracticeSettings$Params, context?: HttpContext): Observable<PracticeSettings> {
    return this.appSettingGetPracticeSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PracticeSettings>): PracticeSettings => r.body)
    );
  }

  /** Path part for operation `appSettingGetApplicationsetting()` */
  static readonly AppSettingGetApplicationsettingPath = '/applicationsetting/getapplicationsetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingGetApplicationsetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetApplicationsetting$Response(params?: AppSettingGetApplicationsetting$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettings>> {
    return appSettingGetApplicationsetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingGetApplicationsetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetApplicationsetting(params?: AppSettingGetApplicationsetting$Params, context?: HttpContext): Observable<ApplicationSettings> {
    return this.appSettingGetApplicationsetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettings>): ApplicationSettings => r.body)
    );
  }

  /** Path part for operation `appSettingSaveApplicationSettings()` */
  static readonly AppSettingSaveApplicationSettingsPath = '/applicationsetting/save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingSaveApplicationSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingSaveApplicationSettings$Response(params: AppSettingSaveApplicationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return appSettingSaveApplicationSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingSaveApplicationSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingSaveApplicationSettings(params: AppSettingSaveApplicationSettings$Params, context?: HttpContext): Observable<Blob> {
    return this.appSettingSaveApplicationSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `appSettingUpdateApplicationSettings()` */
  static readonly AppSettingUpdateApplicationSettingsPath = '/applicationsetting/updateApplicationSetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingUpdateApplicationSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingUpdateApplicationSettings$Response(params: AppSettingUpdateApplicationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return appSettingUpdateApplicationSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingUpdateApplicationSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingUpdateApplicationSettings(params: AppSettingUpdateApplicationSettings$Params, context?: HttpContext): Observable<Blob> {
    return this.appSettingUpdateApplicationSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `appSettingTestEmail()` */
  static readonly AppSettingTestEmailPath = '/applicationsetting/testEmail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingTestEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingTestEmail$Response(params: AppSettingTestEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return appSettingTestEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingTestEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appSettingTestEmail(params: AppSettingTestEmail$Params, context?: HttpContext): Observable<Blob> {
    return this.appSettingTestEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `appSettingGetAppSettingFromGlobalXmlFile()` */
  static readonly AppSettingGetAppSettingFromGlobalXmlFilePath = '/applicationsetting/getappSettingfromglobalxml';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appSettingGetAppSettingFromGlobalXmlFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetAppSettingFromGlobalXmlFile$Response(params?: AppSettingGetAppSettingFromGlobalXmlFile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettings>> {
    return appSettingGetAppSettingFromGlobalXmlFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appSettingGetAppSettingFromGlobalXmlFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appSettingGetAppSettingFromGlobalXmlFile(params?: AppSettingGetAppSettingFromGlobalXmlFile$Params, context?: HttpContext): Observable<ApplicationSettings> {
    return this.appSettingGetAppSettingFromGlobalXmlFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationSettings>): ApplicationSettings => r.body)
    );
  }

}
